import { render } from "./GameView.vue?vue&type=template&id=75c2b9c6"
import script from "./game-view-component.ts?vue&type=script&lang=js&external"
export * from "./game-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__